/*
 * @Author: chenxuelai 2251702447@qq.com
 * @Date: 2023-08-10 15:58:32
 * @LastEditors: chenxuelai 2251702447@qq.com
 * @LastEditTime: 2023-09-14 10:45:31
 * @FilePath: /vue_huaqiang/src/api/credit-note.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from "@/utils/oms-request";
import download from "@/utils/oms-download";
import exp from "constants";

// /remittance-advices/{id} 查询收汇单信息 GET
export const getRAInfo = (id: any) =>
  request({
    url: `/remittance-advices/${id}`,
    method: "get"
  });
// /remittance-advices/{id}/allocation-info 收汇单分配信息 GET
export const getAllocationInfo = (id: any) =>
  request({
    url: `/remittance-advices/${id}/allocation-info`,
    method: "get"
  });
// /remittance-advices/{id} 更新收汇单 PUT
export const updateRAInfo = (id:any,data) =>
  request({
    url: `/remittance-advices/${id}`,
    method: "put",
    data
  });
// /remittance-advices/{id}/state 作废 PUT
export const updateRAState = (id:any) =>
  request({
    url: `/remittance-advices/${id}/state`,
    method: "put"
  });
// /remittance-advices/{id}/cancel-invalid 取消作废 PUT
export const cancelInvalid = (id:any) =>
  request({
    url: `/remittance-advices/${id}/cancel-invalid`,
    method: "put"
  });
// /remittance-advices/file-infos/{id} 修改附件备注 PUT
export const updateFileRemark = (id:any,data) =>
  request({
    url: `/remittance-advices/file-infos/${id}`,
    method: "put",
    data
  });
// /remittance-advices/{id}/file-infos 附件列表 GET
export const getRAFileList = (id: any) =>
  request({
    url: `/remittance-advices/${id}/file-infos`,
    method: "get"
  });
// /remittance-advices/{id}/file-infos 上传附件 POST
export const uploadRAFile = (id, data) =>
  request({
    url: `/remittance-advices/${id}/file-infos`,
    method: "post",
    data
  });
// /remittance-advices/create 新建收汇单 POST
export const createRATable = (data) =>
  request({
    url: `/remittance-advices/create`,
    method: "post",
    data
  });
// /remittance-advices/types 查询所有的登记类型 GET
export const getRAAllTypes = () =>
  request({
    url: `/remittance-advices/types`,
    method: "get"
  });
// /remittance-advices/states 查询所有的状态 GET
export const getRAAllStates = () =>
  request({
    url: `/remittance-advices/states`,
    method: "get"
  });
// /remittance-advices/search 收汇单列表 GET
export const getRASearch = (params:any) =>
  request({
    url: `/remittance-advices/search`,
    method: "get",
    params
  });
// /remittance-advices/file-infos 删除附件 DELETE
export const deleteRAfile = (params) =>
  request({
    url: `/remittance-advices/file-infos`,
    method: "delete",
    params
  });

  // /remittance-advices/download
export const downloadAdvices = (params: any) =>
  download({
    responseType: "blob",
    url: `/remittance-advices/download`,
    method: "get",
    params
  });

  //  /remittance-advices/{id}/remark
  export const putRemark = (id:any,data) =>
  request({
    url: `/remittance-advices/${id}/remark`,
    method: "put",
    data
  });

  // /remittance-advices/file/url
  export const getUrlList = (params: any) =>
  request({
    url: `/remittance-advices/file/url?${params}`,
    method: "get"
  });

  // 查询收汇单结算信息
  export const getSettlementInfo = (id) =>
    request({
      url: `/remittance-advices/${id}/settlement-info`,
      method: "get"
    });
  // 收汇单结算
  export const postSettlement = (id,data) =>
    request({
      url: `/remittance-advices/${id}/settlement`,
      method: "post",
      data
    });